import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { CalendarTranslateService } from '../../../../../modules/UIKit/services/calendarTranslate.service';
import { CampaignService } from '../../../../../services/campaign/campaign.service';
import { Campaign } from '../../campaign';

@Component({
  selector: 'campaign-stores',
  templateUrl: 'campaign-stores.html',
  styles: [
    '::ng-deep .store-filter-multiselect .ui-chkbox .ui-chkbox-icon { width: 14px !important; line-height: 14px !important; margin: 0px auto !important; }',
    '::ng-deep .store-table .ui-chkbox .ui-chkbox-icon { line-height: 33px !important; width: 33px !important; margin: 0px auto !important; }',
    '::ng-deep .store-table .ui-radiobutton-icon { width: 100%; line-height: 0px !important; margin: 7px auto !important; }'
  ]
})
export class CampaignStoresComponent {

  @Input() campaign: Campaign;
  @Input() savedCategories: any[];
  @Input() returnedSavedCategories: any[];
  @Input() savedProductCouponsF: any[];
  @Input() savedProductCouponsNF: any[];
  @Input() returnedSavedProductCouponsF: any[];
  @Input() returnedSavedProductCouponsNF: any[];
  @Input() targetedStores: string;

  @Output() returnedSavedCategoriesEmitter: EventEmitter<any[]> = new EventEmitter();
  @Output() returnedSavedProductCouponsFemitter: EventEmitter<any[]> = new EventEmitter();
  @Output() returnedSavedProductCouponsNFemitter: EventEmitter<any[]> = new EventEmitter();
  @Output() newTargetedStores: EventEmitter<string> = new EventEmitter();

  public filter: {insegna: string[], area: string[], gruppo: string, codici: string[]};

  public insegne: Array<any> = [];
  public groupNames: Array<any> = [];
  public regionNames: Array<any> = [];

  private calendarTranslate: any;
  private newGroupName: string = '';
  public saveAsGroup: boolean = false;
  public groups: Array<any> = [];
  private selectedGroupsId: string[] = [];
  public stores: Array<any> = [];
  private selectedStoresId: string[] = [];
  private areaGeo: Array<any> = [];

  // popup
  public popupStores: boolean = false;
  public popupGroups: boolean = false;

  translations: any;


  constructor(
    private campaignService: CampaignService,
    private calendarService: CalendarTranslateService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService)
  {
    this.calendarService.pCalendar.subscribe(res => {
      this.calendarTranslate = res;
    });
  }

  ngOnInit()
  {
    this.translate.get([
      'campaign.storeFilterConfirm',
      'campaign.group'
    ]).subscribe( res => {
      this.translations = res;
      this.groupNames = [{ label: res['campaign.group'], value: '' }];
    });

    this.initFilter();
    this.searchStoresWithFilter(this.filter);

    this.campaign.stores = this.campaign.stores || [];
    this.campaign.storesId = this.campaign.storesId || [];

    if(this.campaign.storesId.length == 0) {
      return;
    }

    if (this.targetedStores.length > 0) {
      this.filter.codici = this.targetedStores.split(',');
      this.campaignService.getStoresFromFilters(this.filter).subscribe(
        res => {
          this.campaign.stores = res;
          this.campaign.stores.forEach(store => this.selectedStoresId.push(store.id.toString()));
        },
        error => console.error(error),
        () => {
          this.filter.codici = [];
        }
      );
    }
  }

  togglePopupStores()
  {
    this.popupStores = !this.popupStores;

    if(this.popupStores) {

      if (this.selectedStoresId.length > 0) {
        this.searchStoresWithFilter(this.filter);
      }

      Observable.zip(
        this.campaignService.getInsegna(),
        this.campaignService.getAreaGeo(),
        this.campaignService.listGroups(),
      ).subscribe(([insegne, areaGeo,  groups]) => {
        if (this.insegne.length === 0) {
          insegne.map(insegna => {
            this.insegne.push({
              label: insegna.insegna,
              value: insegna.insegna
            });
          });
        }
        this.areaGeo = areaGeo;
        this.groups = groups;
        this.setFilter();
      });
    }
  }

  setFilter()
  {
    if (this.regionNames.length === 0) {
      this.areaGeo.forEach(area => {
        if(area.descrizione !== null) {
          this.regionNames.push({
            label: `${area.descrizione}`,
            value: area.codice
          });
        }
      });
    }

    this.groups.forEach(group => {
      this.groupNames.push({
        label: group.name,
        value: group.name
      });
    });
  }

  initFilter()
  {
    this.filter = {
      insegna: [],
      area: [],
      gruppo: '',
      codici: []
    };
  }

  confirm() {
    this.confirmationService.confirm({
      message: this.translations['campaign.storeFilterConfirm'],
      accept: () => this.searchStoresWithFilter(this.filter, 'applyBtn'),
      acceptLabel: "Ok",
      rejectLabel: "Annulla"
    })
  }

  searchStoresWithFilter(filters, source?) {
    if (source == 'applyBtn') {
      if (this.selectedStoresId.length > 0) {
        this.selectedStoresId = [];
      }
    }
    this.campaignService.getStoresFromFilters(filters).subscribe(res => {
      this.stores = res;
    })
  }

  updateLocalStores(filterObj = {})
  {
    return this.campaignService.getStoresFromFilters(filterObj).subscribe(res => {
      this.stores = res;
    });
  }

  addStore(storeId: string) {
    this.campaign.stores.push(this.stores.filter( store => store.id == parseInt(storeId) )[0]);
  }

  addStores()
  {
    this.campaign.stores = [];
    for(let storeId of this.selectedStoresId) {
      this.addStore(storeId);
    }
    this.togglePopupStores();
    this.setCampaignStores();
  }

  deleteStore(store_id)
  {
    this.selectedStoresId = this.selectedStoresId.filter( item => parseInt(item) != store_id);
    this.campaign.stores = this.campaign.stores.filter( store => store.id != store_id);
    this.setCampaignStores();
  }

  unselectAll()
  {
    this.selectedStoresId = [];
  }

  selectAll()
  {
    this.selectedStoresId = this.stores.map(store => store.id.toString());
  }

  togglePopupGroups()
  {
    this.popupGroups = !this.popupGroups;
    if(this.popupGroups) {
      this.updateLocalGroups();
    }
  }

  updateLocalGroups()
  {
    return this.campaignService.listGroupsWithStores().subscribe(res => {
      this.groups = res;
    });
  }

  inputGroupName(value: boolean)
  {
    if(value && this.selectedStoresId.length == 0) {
      return;
    }

    if (!value) {
      this.newGroupName = '';
    }

    this.saveAsGroup = value;
  }

  saveGroup()
  {
    if(this.newGroupName == '') {
      return;
    }

    const groupData = {
      'name': this.newGroupName,
      'code': this.generateGroupCode()
    };

    this.inputGroupName(false);

    this.campaignService.createGroup(groupData).subscribe( res => {
      this.newGroupName = '';
      this.campaignService.setStoresInGroup(res.id, this.selectedStoresId.map(store => parseInt(store)))
        .subscribe(res => this.addStores());
    });
  }

  generateGroupCode()
  {
    return Date.now();
  }

  addStoresFromGroups()
  {
    if (this.selectedGroupsId.length == 0) {
      this.campaign.stores = [];
      this.togglePopupGroups();
      return;
    }
    let observablesArray = this.campaignService.listStoresInGroup(this.selectedGroupsId);

    Observable.zip(observablesArray).subscribe(
      groupStores => {
        this.selectedStoresId = [];
        if (this.campaign.stores.length > 0) {
          this.campaign.stores = this.deduplicate([].concat(...groupStores));
          this.campaign.stores.forEach(store => this.selectedStoresId.push(store.id.toString()));
        } else {
          groupStores.forEach(gs => gs.map(store => this.selectedStoresId.push(store.id.toString())));
          this.campaign.stores = groupStores[0];
        }
      },
      e => console.error(e),
      () => {
        this.togglePopupGroups();
        this.setCampaignStores();
      }
    );
  }

  deduplicate(array)
  {
    array = array.filter((element, index) => {
      return (array.findIndex(el => el.code == element.code) == index);
    });
    return array;
  }

  setCampaignStores()
  {
    let selectedStoresCodes: string[] = [];
    this.stores.filter(store => this.selectedStoresId.indexOf(store.id.toString()) != -1).forEach(store => selectedStoresCodes.push(store.host_code));
    this.campaignService.setCampaignStores(this.campaign.name, selectedStoresCodes).subscribe();
    this.newTargetedStores.emit(selectedStoresCodes.join());
  }

  ngOnDestroy() {
    if (this.returnedSavedCategories[0] && this.returnedSavedCategories[0].length > 0 && this.returnedSavedCategories[1] == "step5") {
      this.returnedSavedCategoriesEmitter.emit(this.returnedSavedCategories);
    } else if (this.savedCategories.length > 0) {
      this.returnedSavedCategoriesEmitter.emit([this.savedCategories, "tab"]);
    }

    if (this.returnedSavedProductCouponsF.length == 0 && this.savedProductCouponsF.length > 0) {
      this.returnedSavedProductCouponsFemitter.emit(this.savedProductCouponsF);
    }

    if (this.returnedSavedProductCouponsNF.length == 0 && this.savedProductCouponsNF.length > 0) {
      this.returnedSavedProductCouponsNFemitter.emit(this.savedProductCouponsNF);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/stores/campaign-stores.component.ts